<template lang="pug">
.box
    .box-header.header.b-b
        h3(v-show="mode === 'groups'") Display Groups
            i.material-icons.m-l-sm(
                data-toggle="tooltip",
                data-placement="top",
                title="Display Groups function as “subsections” of your Menu. If you have subsections in your physical menus, like appetizers, wines, or desserts, you can create Display Groups to match with your physical menus."
            ) help
        h3(v-if="mode === 'group-form'") {{ groupExists ? 'Update' : 'Add' }} Display Group

    .box-tool(v-if="canManageOrderDisplayGroup")
        a.nav-link.text-muted(v-if="mode === 'groups'" @click="addNewDisplayGroup()")
            i.material-icons.md-18 add

        a.nav-link.text-muted(v-if="mode !== 'groups'" @click="selectMode('groups')")
            i.material-icons.md-18 close

    div
        div(v-if="mode === 'groups'")
            p.p-a-1.m-b-0.text-center(v-if="!groupList.length && canManageOrderDisplayGroup")
                | Click  
                i.material-icons.text-muted.pointer(@click="addNewDisplayGroup()") add
                |  to add new display group

            .p-a-1.b-b
                input(
                    type="text"
                    name="search"
                    v-model="search"
                    class="form-control"
                    placeholder="Type to search"
                )
            
            ul.list
                li.list-item(v-for="(group, index) in filteredList", :key="`btn_${group.id}`" v-if="index <= 8")
                    .list-body
                    div(style='align-items: center;display: flex; justify-content: space-between;')
                        p.m-b-0 {{ group.name }}
                        .inline.m-l-1(v-if="canManageOrderDisplayGroup")
                            button.btn.white.dropdown-toggle.p-a-xs.btn-xs(
                                data-toggle="dropdown",
                                aria-expanded="true"
                            )
                            .dropdown-menu.dropdown-menu-right
                                a.dropdown-item(@click="editGroup(group)") Edit
                                a.dropdown-item(@click="confirmDeleteGroup(group)") Delete

        div(v-if="mode === 'group-form'")
            .form-group.m-b-0
                label.form-control-label Name
                input.form-control(
                    type="text"
                    v-focus=""
                    v-model="group.name"
                    :disabled="onLoading('save-group')"
                )

    .box-footer.b-t(v-if="mode !== 'groups'")
        fieldset(:disabled="onLoading('save-group')")
            .set-buttons
                button.btn.btn-sm.white(@click="selectMode('groups')")
                    span Cancel

                button.btn.btn-sm.primary(
                    :disabled="group.name == null || group.name.trim() == ''"
                    @click="submit()"
                )
                    span Save
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { OrderLayoutEvent } from '../order-layout-bus';
import LoadingMixin from '../mixins/loading';
import PermissionMixin from '../order-layout-permission';

export default {
    mixins: [PermissionMixin, LoadingMixin],

    data() {
        return {
            mode: 'groups',
            group: {
                id: null,
                name: '',
            },
            search: '',
        };
    },

    computed: {
        ...mapGetters('orderLayout', [
            'groupList',
            'activeGroupId',
            'orderLayout',
            'selectedGrid',
            'getGroupPages',
            'previousPages',
            'pages',
        ]),

        groupExists() {
            return this.group.id !== null;
        },

        filteredList() {
            return this.groupList.filter(group => {
                return group.name
                    .toLowerCase()
                    .includes(this.search.toLowerCase());
            });
        },
    },

    created() {
        OrderLayoutEvent.$on('group-deleted', this.onGroupDeleted);
    },

    mounted() {
        this.$nextTick(() => {
            $('[data-toggle="tooltip"]').tooltip();
        });
    },

    methods: {
        ...mapActions('orderLayout', [
            'createGroup',
            'deleteGroup',
            'setSelectedGrid',
            'setOrCreatePageCell',
            'updateGroup',
            'backToPreviousPage',
            'removePage',
            'removeGroup',
        ]),

        getGroup() {
            let options = {
                query: this.search,
            };

            this.$emit('group_display', options);
        },

        onFiltersChange: _.debounce(function(query) {
            this.getGroup();
        }, 500),

        async confirmDeleteGroup(group) {
            const { value } = await swal({
                title: 'Are you sure?',
                text: "This process can't be undone!",
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#d9534f',
                cancelButtonColor: '#fff',
                cancelButtonClass: 'text-dark',
                confirmButtonText: 'Yes, delete it!',
                showLoaderOnConfirm: true,
                preConfirm: async () => {
                    try {
                        await this.deleteGroup(group.id);
                        return true;
                    } catch (e) {
                        throw e;
                    }
                },
                allowOutsideClick: () => !swal.isLoading(),
            });

            if (value) {
                OrderLayoutEvent.$emit('group-deleted', group.id);
            }
        },

        editGroup(group) {
            this.group = _.clone(group);
            this.selectMode('group-form');
        },

        selectMode(mode) {
            if (this.isLoading) return;
            this.mode = mode;
        },

        addNewDisplayGroup() {
            this.group.id = null;
            this.group.name = null;
            this.selectMode('group-form');
        },

        async submit() {
            if (this.onLoading('save-group')) return;

            this.startLoading('save-group');

            try {
                if (this.groupExists) {
                    await this.updateGroup(this.group);
                } else {
                    await this.createGroup(this.group);
                }

                this.selectMode('groups');
                this.endLoading('save-group');
            } catch (e) {
                this.showApiError(err);
                this.endLoading('save-group');
            }
        },

        onGroupDeleted(groupId) {
            if (this.activeGroupId == groupId) this.backToPreviousPage();

            // if deleted group in navigation back to main page
            if (this.previousPages.filter(p => p.group_id == groupId).length)
                this.viewGroup(null);

            // delete all cell belongs to group
            this.pages.forEach(p => {
                p.cells.forEach(c => {
                    if (c.action_type === 'group' && c.action_id == groupId) {
                        const { x, y } = c;
                        this.setOrCreatePageCell({ page_id: p.id, x, y });
                    }
                });
            });

            // delete all page belongs to group
            this.getGroupPages(groupId).forEach(p => this.removePage(p.id));

            this.removeGroup(groupId);
        },
    },
};
</script>


<style lang="scss" scoped>
@import '../../../../sass/pages/rounded_input';

.dropdown {
    display: inline-block;
}

.form-control-label {
    margin-bottom: 0.5rem;
    padding: 0;
}

.header,
.set-buttons {
    align-items: center;
    display: flex;
    justify-content: space-between;
}

label {
    font-weight: 500;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/order-layout/action/action-groups.vue